(function () {
  const BADGE_CLASS = 'revene-save-badge-live';

  function parsePrice(text) {
    if (!text) return 0;

    let cleaned = text
      .replace(/\s/g, '')
      .replace(/[^\d.,]/g, '');

    if (!cleaned) return 0;

    const hasComma = cleaned.includes(',');
    const hasDot = cleaned.includes('.');

    if (hasComma && hasDot) {
      const lastComma = cleaned.lastIndexOf(',');
      const lastDot = cleaned.lastIndexOf('.');

      if (lastDot > lastComma) {
        cleaned = cleaned.replace(/,/g, '');
      } else {
        cleaned = cleaned.replace(/\./g, '');
        cleaned = cleaned.replace(',', '.');
      }
    } else if (hasComma) {
      cleaned = cleaned.replace(',', '.');
    }

    return parseFloat(cleaned) || 0;
  }

  function getPriceElements(productPrice) {
    const saleContainer =
      productPrice.querySelector('.price__sale:not(.price__hidden)');

    if (!saleContainer) {
      return null;
    }

    const salePriceElement =
      saleContainer.querySelector('.price-item--sale.price');

    const comparePriceElement =
      saleContainer.querySelector(
        '.price-item--regular.compare-at-price'
      );

    if (!salePriceElement || !comparePriceElement) {
      return null;
    }

    return {
      saleContainer,
      salePriceElement,
      comparePriceElement
    };
  }

  function removeBadge(productPrice) {
    const badge =
      productPrice.querySelector('.' + BADGE_CLASS);

    if (badge) {
      badge.remove();
    }
  }

  function updatePriceBlock(productPrice) {
    const elements = getPriceElements(productPrice);

    if (!elements) {
      removeBadge(productPrice);
      return;
    }

    const {
      saleContainer,
      salePriceElement,
      comparePriceElement
    } = elements;

    const salePrice =
      parsePrice(salePriceElement.textContent);

    const comparePrice =
      parsePrice(comparePriceElement.textContent);

    if (
      salePrice <= 0 ||
      comparePrice <= 0 ||
      comparePrice <= salePrice
    ) {
      removeBadge(productPrice);
      return;
    }

    const savingPercent =
      Math.round(
        ((comparePrice - salePrice) / comparePrice) * 100
      );

    if (savingPercent <= 0) {
      removeBadge(productPrice);
      return;
    }

    let badge =
      productPrice.querySelector('.' + BADGE_CLASS);

    if (!badge) {
      badge = document.createElement('span');
      badge.className = BADGE_CLASS;
    }

    badge.textContent =
      'SAVE ' + savingPercent + '%';

    badge.setAttribute(
      'aria-label',
      'Save ' + savingPercent + ' percent'
    );

    badge.style.display = 'inline-flex';
    badge.style.alignItems = 'center';
    badge.style.justifyContent = 'center';
    badge.style.marginLeft = '10px';
    badge.style.padding = '3px 8px';
    badge.style.minHeight = '22px';
    badge.style.backgroundColor = '#c62828';
    badge.style.color = '#ffffff';
    badge.style.fontSize = '12px';
    badge.style.fontWeight = '700';
    badge.style.lineHeight = '1';
    badge.style.whiteSpace = 'nowrap';
    badge.style.borderRadius = '0';
    badge.style.verticalAlign = 'middle';
    badge.style.transform = 'translateY(0px)';

    if (salePriceElement.parentElement) {
      salePriceElement.parentElement.insertAdjacentElement(
        'afterend',
        badge
      );
    } else {
      saleContainer.appendChild(badge);
    }
  }

  function updateAllPriceBlocks() {
    const productPrices =
      document.querySelectorAll('product-price');

    productPrices.forEach(function (productPrice) {
      updatePriceBlock(productPrice);
    });
  }

  let scheduled = false;

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      updateAllPriceBlocks();
    });
  }

  function init() {
    updateAllPriceBlocks();

    const observer =
      new MutationObserver(function () {
        scheduleUpdate();
      });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener(
      'shopify:section:load',
      scheduleUpdate
    );

    document.addEventListener(
      'shopify:block:select',
      scheduleUpdate
    );

    document.addEventListener(
      'change',
      function (event) {
        if (
          event.target.closest(
            'variant-picker, product-form, product-info'
          )
        ) {
          setTimeout(scheduleUpdate, 50);
          setTimeout(scheduleUpdate, 250);
        }
      },
      true
    );

    setTimeout(updateAllPriceBlocks, 250);
    setTimeout(updateAllPriceBlocks, 750);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }
})();